import React, { useState } from "react";
import { useAuth } from "../context/auth";

export default function Login({ returnToLanding }) {
  const { login, authError, clearError } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    clearError();
    e.preventDefault();
    login(email, password);
  };

  return (
    <form onSubmit={handleSubmit} className="column">
      <div className="column form-margin">
        <input
          type="email"
          value={email}
          onChange={(e) => {
            clearError();
            setEmail(e.target.value);
          }}
          placeholder="Email"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => {
            clearError();
            setPassword(e.target.value);
          }}
          placeholder="Password"
        />
      </div>
      <button className="form-margin" type="submit">
        LOG IN
      </button>
      <button type="button" onClick={returnToLanding}>
        back
      </button>
      {authError && <p className="notice">{authError}</p>}
    </form>
  );
}
